import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommunicationsService, OrderService } from '@app/_services';
import * as _ from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { FormDataHelper } from '@app/_helpers';
import { MatButtonModule } from '@angular/material/button';
import { QRCodeModule } from 'angularx-qrcode';
import { IconComponent } from '../icon/icon.component';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-benefit-pay-dialog',
    templateUrl: './benefit-pay-dialog.component.html',
    styleUrls: ['./benefit-pay-dialog.component.scss'],
    providers: [FormDataHelper],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, FlexModule, IconComponent, QRCodeModule, MatButtonModule]
})
export class BenefitPayDialogComponent implements OnInit {

    constructor(private fb: UntypedFormBuilder,
        private orderService: OrderService,
        public bsModalRef: BsModalRef,
        private toastr: ToastrService,
        private fd: FormDataHelper
    ) { }
    form = this.fb.group({
        proof: [null,Validators.required]
    });
    user: any;
    order;
    files: any[] = [];
    file: any;
    url;
    qrData;


    ngOnInit(): void {
        if (this.order) {
            this.qrData = JSON.stringify({ iban: this.order.companyData?.benefitPay?.iban, amount: this.order.payableTotal?.toString() });
        }
    }
    save() {
        if (this.form.invalid) {
            this.toastr.error('Fill in the required fields');
            return
        }
        let paymentProof = new FormData();
        paymentProof = this.fd.ToFormData(this.form.value);
        this.orderService.addPaymentProof(this.order.orderId,paymentProof).subscribe((response: any) => {
            if (response) {
                this.bsModalRef.hide();
                this.toastr.success(response.msg);
            }
        }, (error) => {
            this.toastr.error(error.error?.msg)
        })
    }

    imagebObjectKey(imageObject) {
        return _.findKey(imageObject);
    }

    fileBrowseHandler(files) {
        this.prepareFilesList(files);
    }

    prepareFilesList(files: Array<any>) {
        for (const item of files) {
            this.url = null;
            const reader = new FileReader();
            reader.onload = () => {
                item.url = reader.result as string;
            }
            reader.readAsDataURL(item)
            this.files.push(item);
        }
        this.proof.patchValue(Array.from(files));
    }


    get proof() {
        return this.form.get('proof');
    }

}
